"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../withStyles"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * A component that contains styled "tabs" to be used for navigation. Expects children to be one or more `<Tab />` components. See the source code for more information on how the Tab component is used.
 */


var TabNavigation = function TabNavigation(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      children = _ref.children;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(classes.root, className)
  }, children);
};

var styles = function styles(theme) {
  return {
    root: _defineProperty({
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      width: "100%",
      padding: "12px 8px 36px",
      backgroundColor: theme.colors.white
    }, theme.breakpoints(670), {
      padding: "8px 0px",
      flexDirection: "row",
      alignItems: "center"
    })
  };
};

var _default = (0, _withStyles.default)(styles)(TabNavigation);

exports.default = _default;